var _circle, _path, _path2, _path3, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#F7F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3327 15.334C19.9185 15.334 19.5827 15.6698 19.5827 16.084C19.5827 16.4982 19.9185 16.834 20.3327 16.834V15.334ZM37.3327 35.1673H19.6243V36.6673H37.3327V35.1673ZM19.6243 26.7507H32.3743V25.2507H19.6243V26.7507ZM32.3743 15.334H20.3327V16.834H32.3743V15.334ZM38.0827 21.0423C38.0827 17.8897 35.527 15.334 32.3743 15.334V16.834C34.6985 16.834 36.5827 18.7181 36.5827 21.0423H38.0827ZM32.3743 26.7507C35.527 26.7507 38.0827 24.1949 38.0827 21.0423H36.5827C36.5827 23.3665 34.6985 25.2507 32.3743 25.2507V26.7507ZM15.416 30.959C15.416 28.6348 17.3002 26.7507 19.6243 26.7507V25.2507C16.4717 25.2507 13.916 27.8064 13.916 30.959H15.416ZM19.6243 35.1673C17.3002 35.1673 15.416 33.2832 15.416 30.959H13.916C13.916 34.1116 16.4717 36.6673 19.6243 36.6673V35.1673Z",
    fill: "#8A9AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8988 38.6116C38.4671 38.7961 37.9704 38.7961 37.5387 38.6116C35.6869 37.8203 34.5 35.6073 34.5 33.7109C34.5 31.7995 36.1649 30.25 38.2188 30.25C40.2726 30.25 41.9375 31.7995 41.9375 33.7109C41.9375 35.6073 40.7506 37.8203 38.8988 38.6116Z",
    fill: "white",
    stroke: "#043A87",
    strokeWidth: 1.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2812 33.9688C39.2812 34.5556 38.8056 35.0312 38.2188 35.0312C37.6319 35.0312 37.1562 34.5556 37.1562 33.9688C37.1562 33.3819 37.6319 32.9062 38.2188 32.9062C38.8056 32.9062 39.2812 33.3819 39.2812 33.9688Z",
    fill: "#043A87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5003,
    cy: 16.0833,
    r: 2.83333,
    stroke: "#043A87",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.39b042e74b7db8335d837e385ffd1c36.svg";
export { ForwardRef as ReactComponent };